import { useNavigate } from "react-router-dom";
import { LogOut, Shield } from "lucide-react";
import Seo from "../components/Seo";
import AppLayout from "../components/AppLayout";
import ThemeToggle from "../components/ThemeToggle";
import { useAuth } from "../context/AuthContext";

export default function Settings() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const onLogout = async () => { await logout(); navigate("/login", { replace: true }); };

  return (
    <AppLayout>
      <Seo title="Settings" path="/app/settings" />
      <div className="container-hub py-8 lg:py-12" data-testid="settings-page">
        <h1 className="font-display text-3xl font-semibold tracking-[-0.02em] text-[color:var(--ink)]">Settings</h1>
        <p className="mt-1 text-sm text-[color:var(--ink-soft)]">Manage your account preferences.</p>

        <div className="mt-8 grid grid-cols-1 gap-5">
          <section className="hub-card rounded-2xl p-6">
            <h2 className="font-display text-lg font-semibold text-[color:var(--ink)]">Account</h2>
            <div className="mt-4 grid grid-cols-1 gap-2 text-sm sm:grid-cols-2">
              <div><p className="text-[color:var(--ink-soft)]">Email</p><p className="font-medium text-[color:var(--ink)]" data-testid="settings-email">{user?.email}</p></div>
              <div><p className="text-[color:var(--ink-soft)]">Provider</p><p className="font-medium capitalize text-[color:var(--ink)]">{user?.provider || "email"}</p></div>
              <div><p className="text-[color:var(--ink-soft)]">Member type</p><p className="font-medium text-[color:var(--ink)]">{user?.member_type || "—"}</p></div>
              <div><p className="text-[color:var(--ink-soft)]">Membership</p><p className="font-medium capitalize text-[color:var(--ink)]">{user?.membership_tier || "free"}</p></div>
            </div>
          </section>

          <section className="hub-card rounded-2xl p-6">
            <h2 className="font-display text-lg font-semibold text-[color:var(--ink)]">Appearance</h2>
            <div className="mt-4 flex items-center justify-between">
              <p className="text-sm text-[color:var(--ink-soft)]">Toggle between light and dark theme.</p>
              <ThemeToggle />
            </div>
          </section>

          <section className="hub-card rounded-2xl p-6">
            <h2 className="font-display text-lg font-semibold text-[color:var(--ink)]">Security & privacy</h2>
            <p className="mt-2 text-sm text-[color:var(--ink-soft)]">Change your password by using "Forgot password" on the login screen.</p>
            <div className="mt-5 flex items-center gap-2 text-xs text-[color:var(--ink-soft)]"><Shield className="h-4 w-4" /> Your consents and internal notes are never exposed publicly.</div>
          </section>

          <section className="hub-card rounded-2xl p-6">
            <h2 className="font-display text-lg font-semibold text-[color:var(--ink)]">Session</h2>
            <button onClick={onLogout} data-testid="settings-logout" className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-[color:var(--invert-bg)] px-5 py-2.5 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5">
              <LogOut className="h-4 w-4" /> Log out
            </button>
          </section>
        </div>
      </div>
    </AppLayout>
  );
}
